import * as types from '../actions/actionTypes';
import {LOOK_FEATURE_CONTENT, LOOK_WALLS_ONLY} from "../bvcomponents/look/core/constants";
import {IS_PRODUCT_JOURNEY} from "../config";
import {hardCodeIsEncore} from "../misc/fabricatorHardcode";

const defaultCompatabilityObject = {
  visible: false,
  compatabilityLogic: [],
  clickedFeature: null,
  applyFunction: null
};

const defaultLockedTutorialObject = {
  visible: false,
  step: 0,
  anchorDbFeatureId: null,
  finished: false,
  withGrid: false,
  firstLockedIndex: null,
  firstUnlockedIndex: null,
};

const defaultAllWallsTutorialObject = {
  visible: false,
  lookFeature: null,
  finished: false,
  withGrid: false,
  left: 0,
  top: 0,
  height: 0,
  // featureIndex: null,
};

const initialState = {
  lookOpened: false,
  lookExpanded: false,
  lookParentKeys: [],
  lookViewType: 1,
  lookViewTypeWasChanged: false,
  // wishlistPopupOpened: false,
  sidebarModalOpened: false,
  lookActiveFeature: null,
  lookActiveFeatureStockCount: 0, // to update not in stock
  lookActiveCategory: "", //partId
  moreInfoOpened: "", // main or select
  moreInfoContent: LOOK_FEATURE_CONTENT.info, // main or select,
  lookPageOpened: "",
  lookOverlayOpened: "", // overlay type from constant
  lookOverlayAction: "", // overlay sub type (added for sharing text)
  lookViewChangeOptions: {
    newLayoutType: 1,
    newScene: 1,
    itemsToRemove: [],
  }, // overlay type from constant
  lookStylePopup: {
    notMatchingFeatures: [],
    colors: []
  }, // overlay type from constant
  // lookRemovePopup: {
  //   fromFeature: null,
  // }, // overlay type from constant
  introStep: 0,
  introHidden: true,
  contextMenu: {
    opened: false,
    partId: "",
    layerPosition: "",
    position: {x: 0, y: 0},
    clickedOnItem: "",
  },
  lookWallsApplyTo: hardCodeIsEncore() ? [...LOOK_WALLS_ONLY] : [],
  lookAllWallsOpened: false,
  lookReturnAction: "",
  lookDemoPointsClicked: false,
  lookActiveFeaturePositionInList: null, // is used for navigation only to prevent jumping (null || number)
  navigationCount: 0,
  featureGroupCount: 0, // is used when feature group receives its features, to update other components
  lookCompatabilityAlert: Object.assign({}, defaultCompatabilityObject),
  lookRestoreState: null,
  lookLockedTutorial: Object.assign({}, defaultLockedTutorialObject),
  lookAllWallsTutorial: Object.assign({}, defaultAllWallsTutorialObject),
};

const removeMenuFromState = (state, payload) => {
  if (state.lookExpanded) {
    payload.lookExpanded = false;
  }
  // if (state.lookActiveFeature) {
  //   payload.lookActiveFeature = null;
  // }
  if (state.moreInfoOpened) {
    payload.moreInfoOpened = "";
  }
  if (state.lookAllWallsOpened) {
    payload.lookAllWallsOpened = false;
  }
  if (state.contextMenu.clickedOnItem) {
    state.contextMenu.clickedOnItem = "";
  }
  // if (state.lookActiveCategory) {
  //   payload.lookActiveCategory = "";
  // }
  if (document.body.style.overflow === "hidden") {
    document.body.style.overflow = "";
  }
  return payload
}

export default function(state = initialState, action) {
  let newState = {...state};
  switch(action.type) {
    case types.SET_LOOK_OPENED:
      if (!action.payload.lookOpened) {
        action.payload = removeMenuFromState(state, action.payload);
      } else if (action.payload.isMobile) {
        document.body.style.overflow = "hidden";
      }
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.SET_LOOK_ACTIVE_FEATURE:
      if (!action.payload.lookActiveFeature) {
        if (state.moreInfoOpened) {
          action.payload.moreInfoOpened = "";
        }
        if (state.lookRestoreState && !action.payload.isMobile) {
          action.payload.lookRestoreState = null;
        }
      }
      if (!IS_PRODUCT_JOURNEY) {
        action.payload.lookActiveCategory = action.payload.lookActiveFeature ? action.payload.lookActiveFeature.partId : ""
      }
      if (state.lookOpened && state.lookExpanded) {
        action.payload.lookExpanded = false;
      }
      if (state.lookOpened && state.lookExpanded) {
        action.payload.lookExpanded = false;
      }
      action.payload.lookCompatabilityAlert = Object.assign({}, defaultCompatabilityObject);
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.SET_LOOK_ACTIVE_CATEGORY:
      if (state.moreInfoOpened) {
        action.payload.moreInfoOpened = "";
      }
      if (!action.payload.lookActiveCategory && state.lookRestoreState) {
        action.payload.lookRestoreState = null;
      }
      if (state.contextMenu.clickedOnItem
        && (!action.payload.lookActiveCategory || (action.payload.lookActiveCategory !== "vanity_sink"))) {
        state.contextMenu.clickedOnItem = "";
      }
      action.payload.lookCompatabilityAlert = Object.assign({}, defaultCompatabilityObject);
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.SET_LOOK_EXPANDED:
    case types.SET_LOOK_PARENT_KEYS:
    case types.SET_WISHLIST_POPUP_OPENED:
    case types.SET_SIDEBAR_MODAL_OPENED:
    case types.SET_LOOK_MORE_INFO_OPENED:
    case types.SET_LOOK_PAGE_OPENED:
    case types.SET_LOOK_OVERLAY_OPENED:
    case types.SET_LOOK_INTRO_STEP:
    case types.SET_LOOK_INTRO_HIDDEN:
    case types.SET_LOOK_WALLS_APPLY_TO:
    case types.SET_LOOK_ALL_WALLS_OPENED:
    case types.SET_LOOK_RETURN_ACTION:
    case types.SET_LOOK_DEMO_POINTS_CLICKED:
    case types.SET_LOOK_RESTORE_STATE:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.SET_LOOK_VIEW_TYPE:
      return Object.assign({}, state, {
        ...action.payload, lookViewTypeWasChanged: true
      });
    case types.SET_LOOK_VIEW_CHANGE_OPTIONS:
      return Object.assign({}, state, {
        lookViewChangeOptions: Object.assign({}, state.lookViewChangeOptions, action.payload.lookViewChangeOptions)
      });
    case types.SET_LOOK_STYLE_POPUP:
      return Object.assign({}, state, {
        lookStylePopup: Object.assign({}, state.lookStylePopup, action.payload.lookStylePopup)
      });
    case types.SET_LOOK_REMOVE_POPUP:
      return Object.assign({}, state, {
        lookRemovePopup: Object.assign({}, state.lookRemovePopup, action.payload.lookRemovePopup)
      });
    case types.SET_LOOK_CONTEXT_MENU:
      return Object.assign({}, state, {
        contextMenu: Object.assign({}, state.contextMenu, action.payload.contextMenu)
      });
    case types.SET_LOOK_COMPATABILITY_ALERT:
      return Object.assign({}, state, {
        lookCompatabilityAlert: Object.assign({}, state.lookCompatabilityAlert, action.payload.lookCompatabilityAlert)
      });
    case types.SET_LOOK_LOCK_TUTORIAL:
      return Object.assign({}, state, {
        lookLockedTutorial: Object.assign({}, state.lookLockedTutorial, action.payload.lookLockedTutorial)
      });
    case types.SET_LOOK_ALL_WALLS_TUTORIAL:
      return Object.assign({}, state, {
        lookAllWallsTutorial: Object.assign({}, state.lookAllWallsTutorial, action.payload.lookAllWallsTutorial)
      });
    case types.UPDATE_LOOK_NAVIGATION_COUNT:
      return Object.assign({}, state, {
        navigationCount: state.navigationCount + 1
      });
    case types.UPDATE_LOOK_ACTIVE_FEATURE_STOCK_COUNT:
      return Object.assign({}, state, {
        lookActiveFeatureStockCount: state.lookActiveFeatureStockCount + 1
      });
    case types.SET_WIZARD_ACTIVE_ITEM:
      if (!state.lookOpened && action.payload.wizardActiveItem) {
        return Object.assign({}, state, {
          lookOpened: true,
        });
      }
      break;
    case types.SET_WIZARD_ACTIVE_STEP:
      return Object.assign({}, state, {
        moreInfoOpened: false,
        lookActiveFeaturePositionInList: null,
      });
    default:
      break;
  }
  return newState;
}
